import DocumentsAndWebpagesStep from './DocumentsAndWebpagesStep.vue'
import { documentsAndWebpagesDescriptor } from './descriptor'
import { createDocumentsAndWebpagesController } from './documents-and-webpages-controller'
import { createDocumentsAndWebpagesReviewContribution } from './review-contribution'

const documentsAndWebpagesStepImplementation = Object.freeze({
    descriptor: documentsAndWebpagesDescriptor,
    component: DocumentsAndWebpagesStep,
    createController: createDocumentsAndWebpagesController,
    createReviewContribution: createDocumentsAndWebpagesReviewContribution,
})

export {
    DocumentsAndWebpagesStep,
    createDocumentsAndWebpagesController,
    createDocumentsAndWebpagesReviewContribution,
    documentsAndWebpagesDescriptor,
    documentsAndWebpagesStepImplementation,
}
